import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderSlot as _renderSlot, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-5922d782"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["href", "title", "aria-label"]
const _hoisted_2 = ["tabindex", "aria-label"]
const _hoisted_3 = { class: "buttonLabel" }
const _hoisted_4 = ["tabindex", "aria-label"]
const _hoisted_5 = ["tabindex", "aria-label"]
const _hoisted_6 = { class: "buttonLabel" }
const _hoisted_7 = ["tabindex", "aria-label"]
const _hoisted_8 = ["tabindex", "aria-label"]
const _hoisted_9 = {
  key: 0,
  class: "checkMarkContainer"
}
const _hoisted_10 = {
  key: 2,
  class: "textBefore"
}
const _hoisted_11 = ["title"]
const _hoisted_12 = {
  key: 4,
  class: "textAfter"
}
const _hoisted_13 = ["tabindex", "aria-label"]

import { ComponentPublicInstance, computed, ComputedRef, defineAsyncComponent, Ref, ref } from 'vue';

import { PopupMenuApi } from '@/components/dialogs/popupmenu/PopupMenu.vue';
import { nonCircularCopy, PopupMenuItem } from '@/components/dialogs/popupmenu/PopupMenuItem';
import BrandIcon from '@/components/icons/BrandIcon.vue';
import { useRouter } from '@/composables/router/VueRouter';
import BrowserDetection from '@/data/BrowserDetection';

interface Props {
  value: PopupMenuItem;
  name?: string;
  icon?: string;
  // Flag for option to show focus indication around icons as per BrandIcon.vue
  showIconFocus?: boolean;
  disabled?: boolean;
  isSubMenu?: boolean;
  isRoot?: boolean;
  showChevron?: boolean;
  acceptFocus?: boolean;
  // Flag for option to display menu items horizontally as opposed to the default vertical
  horizontal?: boolean;
  parentValue?: PopupMenuItem;
}
interface Emits {
  (e: 'change', item: PopupMenuItem): void,
  (e: 'itemClicked', value: PopupMenuItem): void,
  (e: 'subMenuToggle'): void,
  (e: 'subMenuOpen'): void,
  (e: 'subMenuClose', closeAll: boolean): void,
}
export interface PopupMenuButtonApi extends ComponentPublicInstance {
  focus: () => void;
  blur: () => void;
  getValue: () => PopupMenuItem;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'PopupMenuButton',
  props: {
    value: {},
    name: {},
    icon: {},
    showIconFocus: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    isSubMenu: { type: Boolean, default: false },
    isRoot: { type: Boolean, default: false },
    showChevron: { type: Boolean, default: false },
    acceptFocus: { type: Boolean, default: true },
    horizontal: { type: Boolean, default: false },
    parentValue: {}
  },
  emits: ["change", "itemClicked", "subMenuToggle", "subMenuOpen", "subMenuClose"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const PopupMenu = defineAsyncComponent(() => import('@/components/dialogs/popupmenu/PopupMenu.vue'));

const router = useRouter();

const props = __props;

const emit = __emit;

const button: Ref<HTMLButtonElement | null> = ref(null);
const subMenu: Ref<PopupMenuApi | null> = ref(null);

function emitItemClicked(): PopupMenuItem {
  emitSubMenuClose();
  emit('itemClicked', props.value);
  return props.value;
}

function getValue(): PopupMenuItem {
  return props.value;
}

const subMenuValue: ComputedRef<PopupMenuItem | undefined> = computed(() => {
  return nonCircularCopy(props.value);
});

function focus(): void {
  button.value?.focus();
}

function blur(): void {
  button.value?.blur();
}

function emitSubMenuToggle(): void {
  // Toggled sub menu
  emit('subMenuToggle');
}

function emitSubMenuOpen(): void {
  // Opened sub menu
  emit('subMenuOpen');
}

function emitSubMenuClose(closeAll: boolean = true): boolean {
  // Closed sub menu
  emit('subMenuClose', closeAll);
  return closeAll;
}

const ariaLabel: ComputedRef<string | null> = computed(() => {
  return props.acceptFocus && props.value.name ? props.value.name : null;
});

const isMobile: ComputedRef<boolean> = computed(() => {
  return BrowserDetection.isMobile();
});

function onSubMenuClose(closeAll: boolean = true): void {
  if (closeAll) {
    emitSubMenuClose();
  }
}

function onKeyPress(event: KeyboardEvent): void {
  if (props.value && !props.value.menuItems) {
    if (!props.horizontal) {
      switch (event.key) {
        case 'ArrowLeft' :
          event.stopImmediatePropagation();
          event.preventDefault();
          emitSubMenuClose(false);
          break;
        case 'ArrowRight' :
          event.stopImmediatePropagation();
          event.preventDefault();
          emitSubMenuOpen();
          break;
        case ' ' :
          event.stopImmediatePropagation();
          event.preventDefault();
          emitSubMenuToggle();
          break;
        case 'Enter' :
          event.stopImmediatePropagation();
          event.preventDefault();
          clicked();
          break;
      }
    } else {
      switch (event.key) {
        case 'ArrowDown' :
          event.stopImmediatePropagation();
          event.preventDefault();
          emitSubMenuClose(false);
          break;
        case 'ArrowUp' :
          event.stopImmediatePropagation();
          event.preventDefault();
          emitSubMenuOpen();
          break;
        case ' ' :
          event.stopImmediatePropagation();
          event.preventDefault();
          emitSubMenuToggle();
          break;
        case 'Enter' :
          event.stopImmediatePropagation();
          event.preventDefault();
          clicked();
          break;
      }
    }
  }
}

function onFocus(): void {
  subMenu.value?.focusMenuOpenerButton();
}

function clicked(): void {
  if (!props.disabled && props.value) {
    switch (props.value.itemType) {
      case 'item_menu' :
        if (props.isRoot) {
          emitSubMenuToggle();
        } else {
          emitSubMenuOpen();
        }
        break;
      case 'item' :
      case 'item_hybrid' :
        if (props.isRoot) {
          emitSubMenuToggle();
        } else {
          if (props.value.route) {
            router.push(props.value.route);
          } else if (props.value.callback) {
            props.value.callback(props.value);
          }
          emitItemClicked();
        }
        break;
      case 'menu' :
        if (props.value.route) {
          router.push(props.value.route);
        } else if (props.value.callback) {
          props.value.callback(props.value);
        } else {
          emitSubMenuToggle();
        }
        break;
      case 'url' :
        window.open(props.value.url, '_blank');
        emitSubMenuClose();
        break;
      case 'action' :
        if (props.value.route) {
          router.push(props.value.route);
        } else if (props.value.callback) {
          props.value.callback(props.parentValue);
        }
        emitSubMenuClose();
        break;
      case 'in_menu_action' :
        if (props.value.callback) {
          props.value.callback(props.parentValue);
        }
        break;
    }
  } else {
    emitItemClicked();
  }
}

function itemSelected(item: PopupMenuItem): void {
  emit('change', item);
}

__expose({
  focus,
  blur,
  getValue,
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_ctx.value && _ctx.value.url)
    ? (_openBlock(), _createElementBlock("a", {
        key: 0,
        class: _normalizeClass(["button popupContainer", { horizontal: _ctx.horizontal, disabled: _ctx.disabled }]),
        href: _ctx.value.url,
        title: _ctx.value.name,
        "aria-label": _ctx.value.name,
        style: _normalizeStyle(_ctx.value.cssStyle),
        target: "_blank"
      }, [
        _createElementVNode("div", {
          ref_key: "button",
          ref: button,
          tabindex: _ctx.acceptFocus ? 0 : -1,
          class: _normalizeClass(["button popupMenuButton", [_ctx.value.itemType, { root: _ctx.isRoot, selected: _ctx.value.selected }]]),
          "aria-label": _ctx.acceptFocus && _ctx.value.name ? _ctx.value.name + ', button' : null,
          onClick: _withModifiers(clicked, ["stop","prevent"]),
          onKeydown: onKeyPress
        }, [
          (_ctx.value.icon)
            ? (_openBlock(), _createBlock(BrandIcon, {
                key: 0,
                class: "icon",
                name: _ctx.value.icon,
                showFocus: _ctx.showIconFocus
              }, null, 8, ["name", "showFocus"]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.value.name), 1)
        ], 42, _hoisted_2)
      ], 14, _hoisted_1))
    : (_ctx.value &&
         (_ctx.value.options && _ctx.value.options.optionsType === 'router') &&
         _ctx.value.itemType === 'item_hybrid' &&
         _ctx.value.menuItems && !_ctx.isRoot)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          ref_key: "button",
          ref: button,
          tabindex: _ctx.acceptFocus ? 0 : -1,
          "aria-label": ariaLabel.value,
          class: _normalizeClass(["button popupContainer", { root: _ctx.isRoot, horizontal: _ctx.horizontal, disabled: _ctx.disabled }]),
          style: _normalizeStyle(_ctx.value.cssStyle),
          onClick: _withModifiers(clicked, ["stop","prevent"]),
          onKeypress: onKeyPress,
          onFocus: onFocus
        }, [
          _createVNode(_unref(PopupMenu), {
            class: _normalizeClass(["subMenu", { root: _ctx.isRoot }]),
            isRoot: false,
            useMenuOpenerButton: false,
            value: subMenuValue.value,
            items: _ctx.value.menuItems,
            ref_key: "subMenu",
            ref: subMenu,
            onSubMenuClose: onSubMenuClose,
            onChange: itemSelected
          }, null, 8, ["class", "value", "items"])
        ], 46, _hoisted_4))
      : (_ctx.value &&
                 (_ctx.value.options && _ctx.value.options.optionsType === 'router') &&
                 _ctx.value.itemType !== 'item_hybrid' &&
                 !_ctx.isRoot)
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 2,
            to: _ctx.value.options.route
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", {
                ref_key: "button",
                ref: button,
                tabindex: _ctx.acceptFocus ? 0 : -1,
                "aria-label": _ctx.acceptFocus && _ctx.value.name ? _ctx.value.name + ', button' : null,
                class: _normalizeClass(["button popupMenuButton", [_ctx.value.itemType, { root: _ctx.isRoot, selected: _ctx.value.selected }]]),
                style: _normalizeStyle(_ctx.value.cssStyle),
                onClick: _withModifiers(clicked, ["stop","prevent"]),
                onKeydown: onKeyPress
              }, [
                (_ctx.value.icon)
                  ? (_openBlock(), _createBlock(BrandIcon, {
                      key: 0,
                      class: "icon",
                      name: _ctx.value.icon,
                      showFocus: _ctx.showIconFocus
                    }, null, 8, ["name", "showFocus"]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.value.name), 1)
                ])
              ], 46, _hoisted_5)
            ], undefined, true),
            _: 1
          }, 8, ["to"]))
        : (_ctx.value && _ctx.value.menuItems && !_ctx.isRoot)
          ? (_openBlock(), _createElementBlock("div", {
              key: 3,
              ref_key: "button",
              ref: button,
              tabindex: _ctx.acceptFocus ? 0 : -1,
              "aria-label": ariaLabel.value,
              class: _normalizeClass(["button popupContainer", { root: _ctx.isRoot, horizontal: _ctx.horizontal, disabled: _ctx.disabled }]),
              style: _normalizeStyle(_ctx.value.cssStyle),
              onClick: _withModifiers(clicked, ["stop","prevent"]),
              onKeypress: onKeyPress,
              onFocus: onFocus
            }, [
              _createVNode(_unref(PopupMenu), {
                class: _normalizeClass(["subMenu", { root: _ctx.isRoot }]),
                isRoot: false,
                useMenuOpenerButton: false,
                value: subMenuValue.value,
                items: _ctx.value.menuItems,
                ref_key: "subMenu",
                ref: subMenu,
                onSubMenuClose: onSubMenuClose,
                onChange: itemSelected
              }, null, 8, ["class", "value", "items"])
            ], 46, _hoisted_7))
          : (_ctx.value)
            ? (_openBlock(), _createElementBlock("div", {
                key: 4,
                ref_key: "button",
                ref: button,
                tabindex: _ctx.acceptFocus ? 0 : -1,
                "aria-label": _ctx.acceptFocus && _ctx.value.name ? _ctx.value.name + ', button' : null,
                class: _normalizeClass(["button popupMenuButton", [_ctx.value.itemType, { root: _ctx.isRoot, selected: _ctx.value.selected, horizontal: _ctx.horizontal, disabled: _ctx.disabled }]]),
                style: _normalizeStyle(_ctx.value.cssStyle),
                onClick: _withModifiers(clicked, ["stop","prevent"]),
                onKeydown: onKeyPress
              }, [
                _renderSlot(_ctx.$slots, "default"),
                (!_ctx.isRoot && _ctx.value.itemType !== 'action' && _ctx.value.itemType !== 'text' && _ctx.value.selected)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      _createVNode(BrandIcon, {
                        class: "checkMark",
                        name: "special/tick",
                        heavy: true,
                        showFocus: false
                      })
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.icon || _ctx.value.icon)
                  ? (_openBlock(), _createBlock(BrandIcon, {
                      key: 1,
                      class: "icon",
                      name: _ctx.icon || _ctx.value.icon,
                      showFocus: _ctx.showIconFocus
                    }, null, 8, ["name", "showFocus"]))
                  : _createCommentVNode("", true),
                (_ctx.value.textBefore && !_ctx.isRoot)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_ctx.value.textBefore), 1))
                  : _createCommentVNode("", true),
                (_ctx.name || _ctx.value.name)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 3,
                      class: _normalizeClass(["buttonLabel", { hasTextAfter: _ctx.value.textAfter && !_ctx.name }]),
                      title: _ctx.name || _ctx.value.name
                    }, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.name || _ctx.value.name), 1)
                    ], 10, _hoisted_11))
                  : _createCommentVNode("", true),
                (_ctx.value.textAfter && !_ctx.isRoot)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(_ctx.value.textAfter), 1))
                  : _createCommentVNode("", true),
                (_ctx.isRoot && _ctx.showChevron)
                  ? (_openBlock(), _createBlock(BrandIcon, {
                      key: 5,
                      class: "icon chevron",
                      showFocus: false,
                      name: "special/chevron-down"
                    }))
                  : _createCommentVNode("", true),
                ((_ctx.value.itemType === 'menu' ||
           _ctx.value.itemType === 'item_menu' || _ctx.value.itemType === 'item_hybrid') && !_ctx.isRoot)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 6,
                      class: _normalizeClass(["subMenuTrigger", [_ctx.value.itemType, isMobile.value]]),
                      title: "Open sub-menu",
                      onClick: _withModifiers(emitSubMenuToggle, ["stop"])
                    }, [
                      ((_ctx.value.itemType === 'item_menu' || _ctx.value.itemType === 'item_hybrid') && isMobile.value)
                        ? (_openBlock(), _createBlock(BrandIcon, {
                            key: 0,
                            class: "icon",
                            showFocus: false,
                            name: "solid/edit-solid"
                          }))
                        : (_ctx.value.itemType === 'menu' ||
                   _ctx.value.itemType === 'item_menu' || _ctx.value.itemType === 'item_hybrid')
                          ? (_openBlock(), _createBlock(BrandIcon, {
                              key: 1,
                              class: "icon",
                              showFocus: false,
                              name: "special/chevron-right"
                            }))
                          : _createCommentVNode("", true)
                    ], 2))
                  : _createCommentVNode("", true)
              ], 46, _hoisted_8))
            : (_openBlock(), _createElementBlock("div", {
                key: 5,
                ref_key: "button",
                ref: button,
                tabindex: _ctx.acceptFocus ? 0 : -1,
                "aria-label": ariaLabel.value,
                class: _normalizeClass(["button popupMenuButton", { root: _ctx.isRoot, disabled: _ctx.disabled }]),
                style: _normalizeStyle(_ctx.value.cssStyle),
                onKeydown: onKeyPress
              }, [
                _renderSlot(_ctx.$slots, "default"),
                _createVNode(_unref(PopupMenu), {
                  class: _normalizeClass(["subMenu", { root: _ctx.isRoot }]),
                  isRoot: false,
                  ref_key: "subMenu",
                  ref: subMenu,
                  onSubMenuClose: onSubMenuClose,
                  onChange: itemSelected
                }, null, 8, ["class"])
              ], 46, _hoisted_13))
}
}

})